import { useSelector } from 'react-redux';
import AdditionalFields from './AdditionalFields';
import MappedFields from './MappedFields';

const SubmitSection = () => {
    const { stepVal } = useSelector((state) => state.Uploads);

    return (
        stepVal === 3 ? (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-stretch">
                <div className="col">
                    <MappedFields/>
                </div>
                <div className="col">
                    <AdditionalFields/>
                </div>
            </div>
        ) : null
    );
}

export default SubmitSection;
